import { useState, useEffect } from "react";
import { Upload, CheckCircle } from "lucide-react";

export default function FileUploadBox({
  label,
  description,
  name,
  accept,
  handleInputChange,
  uploadedFile,
  fullWidth = false,
}) {

  const [isDragging, setIsDragging] = useState(false);
  const [fileName, setFileName] = useState(uploadedFile ? uploadedFile.name : "");
  const [isUploaded, setIsUploaded] = useState(!!uploadedFile);

  useEffect(() => {
    if (uploadedFile) {
      setIsUploaded(true);
      setFileName(uploadedFile.name);
    }
  }, [uploadedFile]);

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) {
      handleInputChange({ target: { name, files: [file] } });
      setFileName(file.name);
      setIsUploaded(true);
    }
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleInputChange(e);
      setFileName(file.name);
      setIsUploaded(true);
    }
  };

  return (
    <div
      className={`border-2 border-dashed rounded-lg p-1 text-center transition-all duration-300 
        ${isUploaded
          ? "border-green-500 bg-green-50 shadow-md"
          : isDragging
          ? "border-blue-500 bg-blue-50"
          : "border-gray-300 hover:border-blue-500"} 
        ${fullWidth ? "md:col-span-2" : ""}`}
      onDragOver={(e) => {
        e.preventDefault();
        setIsDragging(true);
      }}
      onDragLeave={() => setIsDragging(false)}
      onDrop={handleDrop}
    >
      <div className="flex flex-col items-center justify-center">
        {isUploaded ? (
          <CheckCircle className="w-6 h-6 text-green-600 mb-2" />
        ) : (
          <Upload className="w-5 h-5 text-gray-400 mb-2" />
        )}
        <h3 className="text-md font-medium text-gray-700 mb-1">{label}</h3>
        <p className="text-xs text-gray-500 mb-2">{description}</p>

        <input
          type="file"
          name={name}
          onChange={handleChange}
          className="hidden"
          id={name}
          accept={accept}
        />
        <label
          htmlFor={name}
          className={`inline-block px-1 py-0 text-xs rounded-md cursor-pointer transition
            ${isUploaded ? "bg-green-600 hover:bg-green-700" : "bg-blue-600 hover:bg-blue-700"}
            text-white`}
        >
          {isUploaded ? "Change File" : "Choose File"}
        </label>

        {/* ✅ File name display */}
        {fileName ? (
          <p className="text-sm text-gray-700 mt-1 truncate font-medium">
            <strong>Uploaded:</strong> {fileName}
          </p>
        ) : (
          <p className="text-xs text-gray-400 mt-1 italic">No file selected</p>
        )}
      </div>
    </div>
  );
}
